import * as types from '../mutations-types'

import {
  fetchInMission,
  fetchPathsViewerByPoint,
  fetchVehicleTypes,
  currentVehicles,
  fetchVehicles,
  fetchVehicleById,
  filterPositionsByVehicleId,
  loadMorePositions,
  getPlace,
  updateVehicle
} from '../../utils/api'

import {createActionHelpers} from 'vuex-loading'

import Vue from 'vue'

import zoomMapBoundaries from '../../utils/zoomMapBoundaries'

import { trackDataSearchedFilters } from '../../utils/trackDataLogs'

const {startLoading} = createActionHelpers({
  moduleName: 'loading'
})

const limitsObj = new Map([
  ['V0', {}],
  ['S0', {isLimit: true, limit1: 15, limit2: 0}],
  ['S1', {isLimit: false, limit1: 15, limit2: 30}],
  ['S2', {isLimit: false, limit1: 30, limit2: 60}],
  ['S3', {isLimit: false, limit1: 60, limit2: 120}],
  ['S4', {isLimit: false, limit1: 120, limit2: 240}],
  ['S5', {isLimit: false, limit1: 240, limit2: 480}],
  ['S6', {isLimit: false, limit1: 480, limit2: 1440}],
  ['S7', {isLimit: false, limit1: 1440, limit2: 4320}],
  ['S8', {isLimit: false, limit1: 4320, limit2: 43200}],
  ['S9', {isLimit: true, limit1: 0, limit2: 43200}]
])

// STATE
const state = {
  statuses: {},
  devices: {},
  isFiltering: false,
  inMissionFilter: null,
  lastPositionSearch: [],
  filterByAZ: false,
  currentMarkersLength: 0,
  lastPositionFilteredCondition: [],
  filteredTempAll: [],
  filterCondition: null,
  filterApplied: false,
  mainAgency: null,
  showClearSearchBtn: false,
  ignition: null,
  stateVehicleSelected: [],
  vehiclesWithoutAgency: [],
  searchingVehicle: false,
  vehicleDataTemp: {},
  chipSerialYesNot: false,
  vehicleTypes: null,
  showLoadingVehicleData: false,
  showClearFilterBtn: false,
  geostringFilters: null,
  lastPolygonsFilter: null,
  lastPositionFiltered: [],
  lastPositionsInit: [],
  allVehiclesUnfiltered: [], // Store minimal vehicle data for SOS permission checking
  realTimeVehicles: [],
  showPointsSection: false,
  showPointsMessage: false,
  vehicles: [],
  selectedVehicle: null,
  vehicleData: {},
  showSuccessMessageUp: false,
  successMessageUp: '',
  nameRules: [
    v => !!v || 'El Nombre es requerido',
    v =>
      (v && v.length >= 3) ||
      'Un Nombre válido debe contener por lo menos 3 letras'
  ],
  selectRules: [
    v => !!v || 'Seleccione una opción por favor'
  ],
  modelRules: [
    v => !!v || 'El Modelo es requerido',
    v => (v && v.length === 4) || 'El modelo debe ser el año en 4 dígitos'
  ],
  colorRules: [
    // v => !!v || 'El Color es requerido',
    v =>
      (v && v.length >= 3) ||
      'Un Color válido debe contener por lo menos 3 letras'
  ],
  chipSerialRules: [
    v => !!v || 'El Serial del Chip es requerido',
    v =>
      (v && v.length >= 3) ||
      'Un serial válido debe contener por lo menos 3 caracteres'
  ],
  inMissionDataFullKPI: [],
  cancelTokenInMissionData: null,
  searchVehicle: false,
  infoWinOpen: false
}
// GETTERS
const getters = {
  statuses: state => state.statuses,
  devices: state => state.devices,
  vehicleInfo: state => vehicleId => {
    const fullVehicles = [...state.lastPositionsInit, ...state.vehiclesWithoutAgency]
    // console.log('vehicleInfo', vehicleId)
    return fullVehicles.find(item => item.id === vehicleId)
  },
  isFiltering: state => state.isFiltering,
  inMissionFilter: state => state.inMissionFilter,
  vehiclePlate: state => device => {
    const fullVehicles = [...state.lastPositionsInit, ...state.vehiclesWithoutAgency]
    const vehicle = fullVehicles.find(item => item.deviceId === device)
    return vehicle ? vehicle.licensePlate : null
  },
  lastPositionSearch: state => state.lastPositionSearch,
  filterByAZ: state => state.filterByAZ,
  currentMarkersLength: state => state.currentMarkersLength,
  lastPositionFilteredCondition: state => state.lastPositionFilteredCondition,
  filteredTempAll: state => state.filteredTempAll,
  filterCondition: state => state.filterCondition,
  filterApplied: state => state.filterApplied,
  mainAgency: state => state.mainAgency,
  getAgencyId: state => deviceId => {
    const vehicle = state.lastPositionsInit.find(item => item.deviceId === deviceId)
    if (vehicle !== undefined) return vehicle.agencyId
    else return null
  },
  vehicleId: state => device => {
    const fullVehicles = [...state.lastPositionsInit, ...state.vehiclesWithoutAgency]
    const vehicle = fullVehicles.find(item => item.deviceId === device)
    return vehicle ? vehicle.id : null
  },
  vehicleCode: state => device => {
    const fullVehicles = [...state.lastPositionsInit, ...state.vehiclesWithoutAgency]
    const vehicle = fullVehicles.find(item => item.deviceId === device)
    return vehicle ? vehicle.code : null
  },
  vehicleLicensePlate: state => device => {
    const fullVehicles = [...state.lastPositionsInit, ...state.vehiclesWithoutAgency]
    const vehicle = fullVehicles.find(item => item.deviceId === device)
    return vehicle ? vehicle.licensePlate : null
  },
  showClearSearchBtn: state => state.showClearSearchBtn,
  ignition: state => state.ignition,
  stateVehicleSelected: state => state.stateVehicleSelected,
  vehiclesWithoutAgency: state => state.vehiclesWithoutAgency,
  searchingVehicle: state => state.searchingVehicle,
  vehicleDataTemp: state => state.vehicleDataTemp,
  chipSerialYesNot: state => state.chipSerialYesNot,
  chipSerialRules: state => state.chipSerialRules,
  realTimeVehicleLocation: state => {
    let realTimePosition = []
    if (state.selectedVehicle !== null) realTimePosition = state.lastPositionsInit.filter(item => item.id === state.selectedVehicle.id)
    // console.log('realTimeVehicleLocation -> realTimePosition', realTimePosition)
    return realTimePosition.length > 0 ? realTimePosition[0] : null
  },
  vehicleTypes: state => state.vehicleTypes,
  showLoadingVehicleData: state => state.showLoadingVehicleData,
  showClearFilterBtn: state => state.showClearFilterBtn,
  geostringFilters: state => state.geostringFilters,
  lastPositionFiltered: state => state.lastPositionFiltered,
  lastPositionsInit: state => state.lastPositionsInit,
  allVehiclesUnfiltered: state => state.allVehiclesUnfiltered,
  realTimeVehicles: state => state.realTimeVehicles,
  vehicleData: state => state.vehicleData,
  showPointsSection: state => state.showPointsSection,
  showPointsMessage: state => state.showPointsMessage,
  getFilteredVehicles: (state, getters) => {
    const zoneGeostrings = getters['filters/zoneGeostrings']
    return state.vehicles.filter(vehicle => {
      if (zoneGeostrings.length === 0) {
        return true
      }
      return zoneGeostrings.some(zone => {
        let {lastPosition} = vehicle
        let path = window.google.maps.geometry.encoding.decodePath(zone.geostring)
        let polygon = new window.google.maps.Polygon({paths: path})
        let location = new window.google.maps.LatLng(lastPosition.lat, lastPosition.lng)
        return window.google.maps.geometry.poly.containsLocation(location, polygon)
      })
    })
  },
  getVehicles: state => {
    return state.vehicles
  },
  getSelectedVehicle: state => {
    return state.selectedVehicle
  },
  nameRules: state => state.nameRules,
  selectRules: state => state.selectRules,
  modelRules: state => state.modelRules,
  colorRules: state => state.colorRules,
  successMessageUp: state => state.successMessageUp,
  inMissionDataFullKPI: state => state.inMissionDataFullKPI,
  cancelTokenInMissionData: state => state.cancelTokenInMissionData,
  searchVehicle: state => state.searchVehicle,
  infoWinOpen: state => state.infoWinOpen
}
// ACTIONS
const actions = {
  processInMissionData({commit}) {
    commit(types.SET_IS_FILTERING, true)
    return new Promise(async(resolve, reject) => {
      try {
        await fetchInMission()
          .then(data => {
            if (data.data) {
              // console.log('processInMissionData DATA: ', data)
              commit(types.UPDATE_IN_MISSION_DATA, data.data)
            }
            resolve()
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  },
  discretFetchVehicleById({commit, state}, vehicleId) {
    // console.log('discretFetchVehicleById: ', vehicleId, state.vehicleData.id)
    return new Promise(async(resolve, reject) => {
      try {
        await fetchVehicleById(vehicleId)
          .then(vehicle => {
            if (vehicle.data) {
              if (vehicle.data.id === state.vehicleData.id) {
                commit(types.UPDATE_STATUSES_DEVICES_VEHICLE_DATA, vehicle.data)
              }
              resolve()
            }
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  },
  updateVehicleInMissionPusher({commit}, data) {
    commit(types.UPDATE_VEHICLE_IN_MISSION_PUSHER, data)
  },
  updateVehicleStatusPusher({commit, state, dispatch}, data) {
    commit(types.UPDATE_VEHICLE_STATUS_PUSHER, data)
    if (state.vehicleData && state.vehicleData.id === data.v) {
      dispatch('discretFetchVehicleById', data.v)
    }
  },
  setIsFiltering({commit}, value) {
    commit(types.SET_IS_FILTERING, value)
  },
  setInMissionFilter({commit}, value) {
    commit(types.SET_IN_MISSION_FILTER, value)
  },
  addST2SelectedVehicle({commit}, value) {
    commit(types.ADD_ST2_SELECTED_VEHICLE, value)
  },
  updateSelectedVehicle({commit}, data) {
    commit(types.UPDATE_SELECTED_VEHICLE, data)
  },
  fetchPathsViewerByPoint({commit, dispatch}, payload) {
    return new Promise(async(resolve, reject) => {
      const dataArray = await startLoading(dispatch, 'filterPositionsByVehicleId', () => {
        return fetchPathsViewerByPoint(payload)
      })
      if (dataArray) {
        // console.log('DATA fetchPathsViewerByPoint', dataArray)
        resolve(dataArray)
      }
      reject(new Error('Error FPVBP'))
    })
  },
  setFilterByAZ({commit}, value) {
    commit(types.SET_FILTER_BY_AZ, value)
  },
  setCurrentMarkersLength({commit}, value) {
    commit(types.SET_CURRENT_MARKERS_LENGTH, value)
  },
  setFilterCondition({commit}, data) {
    commit(types.SET_FILTER_CONDITION, data)
  },
  updateFilterCondition({ commit }, value) {
    commit(types.UPDATE_FILTER_CONDITION, value)
  },
  setFilterApplied({commit}, value) {
    commit(types.FILTER_APPLIED, value)
  },
  newOperationAction({commit, state, dispatch, rootGetters}, data) {
    // console.log('NEW OPERATION ACTION: ', data.operation, data)
    const operation = data.operation
    switch (operation) {
      case 'up':
        const agencyData = rootGetters.agenciesMap.get(data.vehicle.agencyId)
        // console.log('AGENCY DATA: ', agencyData)
        if (rootGetters.mainAgency !== null) {
          // agencyData puede ser undefined si la agencia del vehículo no está
          // en el árbol scoped del token; en ese caso no se agrega el vehículo,
          // evitando leer superParentId de undefined.
          if (agencyData && agencyData.superParentId === rootGetters.mainAgency) {
            // console.log('ALLOWED VEHICLE')
            commit(types.UP_VEHICLE, data)
          } else console.error('NOT ALLOWED VEHICLE')
        } else commit(types.UP_VEHICLE, data)
        break
      case 'update':
        commit(types.UPDATE_VEHICLE, data)
        break
      case 'down':
        commit(types.DOWN_VEHICLE, data)
        break
      default:
        break
    }

    if (state.vehicleData && state.vehicleData.id === data.vehicle.id) {
      dispatch('discretFetchVehicleById', data.vehicle.id)
    }
  },
  async fetchVehicleTypes({commit, dispatch}) {
    await startLoading(dispatch, 'fetchVehicleTypes', () => {
      return fetchVehicleTypes()
    })
      .then(data => {
        commit(types.FETCH_VEHICLE_TYPES, data)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('FVT', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else console.error('FVT', error)
      })
  },
  async lastPositions({commit, dispatch, rootGetters}) {
    console.log('🚀 ACTION LAST POSITION AKA CURRENT! Starting to fetch vehicles...')
    await startLoading(dispatch, 'fetchLastPositions', () => {
      return currentVehicles()
    })
      .then(data => {
        let currentVehicles = data.data

        // Store minimal vehicle data for SOS permission checking (only needed fields)
        const minimalVehicleData = currentVehicles.map(v => ({
          id: v.id,
          deviceId: v.deviceId,
          licensePlate: v.licensePlate,
          agencyId: v.agencyId
        }))
        console.log('🚗 Storing', minimalVehicleData.length, 'vehicles in allVehiclesUnfiltered')
        console.log('🔍 Sample vehicles:', minimalVehicleData.slice(0, 3))
        commit(types.SET_ALL_VEHICLES_UNFILTERED, minimalVehicleData)

        const role = rootGetters['auth/role']
        // console.log('ROLE: ', role)
        if (role.length === 1) commit(types.SET_MAIN_AGENCY, role[0])
        else commit(types.SET_MAIN_AGENCY, null)

        const adminRole = rootGetters['auth/adminRole']
        // console.log('ROLE - ADMINROLE', role, adminRole)
        let currentVehiclesFiltered = []
        let vehiclesWithoutAgencyTemp = []
        let vehiclesWithoutAgencyFinal = []
        if (role.length > 0) {
          // console.log('agenciesMap: ', rootGetters.agenciesMap)
          const agenciesMap = rootGetters.agenciesMap
          // console.log('AGENCIES MAP:', agenciesMap)
          role.forEach(role => {
            const currentVehiclesTemp = currentVehicles.filter(item => {
              // console.log('ITEM:', item)
              // if (item.agencyId !== null && item.agencyId < 118) {
              if (item.agencyId !== null) {
                // console.log('ID:', item.id)
                // La agencia puede no estar en el mapa (p. ej. vehículo de otra
                // agencia/cliente no presente en el árbol scoped del token). En
                // ese caso el vehículo no pertenece a este rol y se descarta,
                // evitando leer superParentId de undefined.
                const agencyEntry = agenciesMap.get(item.agencyId)
                const result = agencyEntry ? agencyEntry.superParentId === role : false
                return result
              } else {
                vehiclesWithoutAgencyTemp.push(item)
                return false
              }
            })
            vehiclesWithoutAgencyFinal = vehiclesWithoutAgencyTemp
            vehiclesWithoutAgencyTemp = []
            currentVehiclesFiltered = currentVehiclesFiltered.concat(currentVehiclesTemp)
          })
          currentVehicles = currentVehiclesFiltered
        } else if (adminRole !== 500 || adminRole !== 400) {
          currentVehicles = []
        }
        // const testNull = currentVehicles.filter(item => item.initialStoppedTime === null)
        // console.log('TEST NULL : ', testNull)

        // console.log('CURRENT VEHICLES: ', currentVehicles)
        // console.log('vehiclesWithoutAgencyFinal: ', vehiclesWithoutAgencyFinal)
        // 25, 457, 764, 906, 1091, 1184, 1207, 1241, 1617, 1638, 1652, 1724
        // const filterId = [25, 457, 764, 906, 1091, 1184, 1207, 1241, 1617, 1638, 1652, 1724]
        // const currentVehiclesFilterId = currentVehicles.filter(item => {
        //   let result
        //   for (let index = 0; index < filterId.length; index++) {
        //     const element = filterId[index]
        //     if (item.id === element) {
        //       result = false
        //       break
        //     } else result = true
        //   }
        //   // console.log('RESULT: ', result)
        //   return result
        // })

        // console.log('CURRENT VEHICLES currentVehiclesFilterId: ', currentVehiclesFilterId)s
        // commit(types.LAST_POSITIONS_INIT, currentVehiclesFilterId)

        // commit(types.LAST_POSITIONS_INIT, [])
        commit(types.LAST_POSITIONS_INIT, currentVehicles)
        commit(types.VEHICLES_WITHOUT_AGENCY, vehiclesWithoutAgencyFinal)
        // console.log('VEHICLES WITHOUT AGENCY vehiclesWithoutAgencyFinal: ', vehiclesWithoutAgencyFinal)
        // commit(types.SHOW_INIT_DIALOG, false)
        // dispatch('displayFiltersHome', true)
      })
      .catch(error => {
        if (error.hasOwnProperty('response')) {
          console.error('LP', error.response)
          if (error.response.status === 401) dispatch('auth/logout')
        } else {
          // commit(types.SHOW_INIT_DIALOG, false)
          // dispatch('displayFiltersHome', true)
          console.error('LP', error)
        }
      })
  },
  async fetchVehicles({commit, dispatch}) {
    const {data} = await startLoading(dispatch, 'fetchingVehicles', () => {
      return fetchVehicles()
    })
    commit(types.FETCH_VEHICLES, data.data)
  },
  fetchVehicleById({commit}, vehicleId) {
    commit(types.SHOW_LOADING_VEHICLE_DATA, true)
    return new Promise(async(resolve, reject) => {
      try {
        await fetchVehicleById(vehicleId)
          .then(vehicle => {
            if (vehicle.data) {
              // console.log('fetchVehicleById VEHICLE PROMISE', vehicle.data)
              vehicle.data.location = vehicle.data.lastPosition
              commit(types.SELECT_VEHICLE, vehicle.data)
              commit(types.FILL_VEHICLE_DATA, vehicle.data)
              commit(types.SHOW_LOADING_VEHICLE_DATA, false)
              resolve()
            }
          })
          .catch(error => {
            reject(new Error(error.response))
          })
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  },
  // filterPositionsByVehicleId({commit, dispatch}, {id, startDate = null, page, from = null, to = null}) {
  filterPositionsByVehicleId({commit, dispatch}, {id, date1 = null, page, time1Date1 = null, time2Date1 = null, date2 = null, time1Date2 = null}) {
    return new Promise(async(resolve, reject) => {
      const {data} = await startLoading(dispatch, `fetchingPositionsVehicle${id}`, () => {
        return filterPositionsByVehicleId({id, date1, time1Date1, time2Date1, date2, time1Date2})
      })
      if (data) {
        const amountOfPoints = data.data.length
        let value = false
        if (amountOfPoints > 0) value = true
        resolve(data)
        commit(types.SHOW_POINTS, value)
        commit(types.SHOW_POINTS_MESSAGE, value)
      }
      reject(new Error('Error Filter Position By Vehicle Id'))
    })
  },
  selectVehicle({commit}, vehicle) {
    commit(types.SELECT_VEHICLE, vehicle)
  },
  updateVehiclePosition({commit}, updatedVehicle) {
    commit(types.UPDATE_VEHICLE_POSITION, updatedVehicle)
  },
  loadMorePointsAction({dispatch}, payload) {
    return new Promise(async(resolve, reject) => {
      try {
        const data = await startLoading(dispatch, 'loading more positions', () => {
          return loadMorePositions(payload)
        })
        if (data) {
          resolve(data)
        }
        reject(new Error('Error at Load More Positions Action'))
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  },
  getPlaceAction(data, payload) {
    return new Promise(async(resolve, reject) => {
      const {data: place} = await getPlace(payload)
      if (place) resolve(place)
      reject(new Error('Error Getting Place'))
    })
  },
  addVehicleData({commit}, data) {
    commit(types.ADD_VEHICLE_DATA, data)
  },
  updateVehicleData({dispatch, commit, state, rootGetters}) {
    let agencyId = null
    if (rootGetters.agencySelected) agencyId = rootGetters.agencySelected.agencyId
    // console.log('agencySelected', agencyId)
    if (agencyId) {
      const data = { key: 'agencyId', value: agencyId }
      commit(types.ADD_VEHICLE_DATA_TEMP, data)
    }
    return new Promise(async(resolve, reject) => {
      const response = await startLoading(dispatch, 'Updating vehicle', () => {
        return updateVehicle(state.vehicleData.id, state.vehicleDataTemp, state.chipSerialYesNot)
      })
      if (response) {
        // console.log(response)
        resolve(response)
        dispatch('fetchVehicles')
        const data = {
          nameA: 'showSuccessMessageUp',
          nameM: 'successMessageUp',
          show: true,
          message: 'Los datos del vehículo se actualizaron correctamente'
        }
        commit(types.CONTROL_MESSAGE, data)
      }
      reject(new Error('Error Updating Vehicle'))
    })
  },
  realtimeVehiclesData({commit, state, getters}, data) {
    // const sample = data.filter(item => item.v === 1632)
    // const sample1 = data.filter(item => item.v === 528)
    // const sample2 = data.filter(item => item.v === 1481)
    // console.log('SAMPLE: ', sample)
    // console.log('SAMPLE 1: ', sample1)
    // console.log('SAMPLE 2: ', sample2)
    // console.log('REAL TIME VEHICLES DATA: ', data)

    const actions = [
      {
        message: 'realtime1',
        func: (vehicles, data, filtered) => {
          // console.log('WORKER REAL TIME')
          // const typedArray1 = new Uint8Array(vehicleBuffer)
          // const vehicles = [...typedArray1]

          // const typedArray2 = new Uint8Array(dataBuffer)
          // const data = [...typedArray2]

          if (vehicles.byteLength) {
            alert('Transferables are not supported in your browser!')
          } else {
            // Transferables are supported.
            // console.log('Transferables are supported')
            // console.log('New Data')
          }
          // let dataTemp = []
          // const vehicles = ['HI!']
          // console.log('*********************************************************')
          for (let index = 0; index < data.length; index++) {
            const element = data[index]
            // console.log(`-- ${index} -----------------------`)
            // console.log('ITEM: ', element)
            // console.log(`time: ${element.t2} | lat: ${element.la} - lng: ${element.lo}`)
            for (let index1 = 0; index1 < vehicles.length; index1++) {
              const item = vehicles[index1]
              const match = item.id === element.v
              const timeTempNew = element.t2
              const timeTempOld = item.location.time

              const dateTime1 = new Date(timeTempNew)
              const dateTime2 = new Date(timeTempOld)

              // console.log('--WB - dateTime1', dateTime1)
              // console.log('--WB - dateTime2', dateTime2)
              // console.log('--WB - dateTime1 <= dateTime2', dateTime1 <= dateTime2)

              const matchTime = dateTime1 > dateTime2
              // if (element.v === 1353 && match) console.log('item', match, matchTime, element.v)

              if (match) {
                // console.log('WORKER REAL TIME MATCH', index1)
                if (matchTime) {
                  vehicles[index1].location.time = element.t2
                  vehicles[index1].location.ignitionStatus = element.is
                  vehicles[index1].location.eventType = element.e
                  vehicles[index1].location.lat = element.la
                  vehicles[index1].location.lng = element.lo
                  vehicles[index1].location.direction = element.di
                  vehicles[index1].location.speed = element.sp
                  vehicles[index1].location.GPSValid = element.gp
                  vehicles[index1].stoppedTimeSinceV2 = element.st2
                  vehicles[index1].mainBatteryVoltage = element.bat
                  vehicles[index1].numberOfSatellites = element.sat
                  // vehicles[index1].stoppedTime = element.st
                  // vehicles[index1].initialStoppedTime = element.sit
                  // vehicles[index1].initialStoppedTimeVerbose = element.sitV
                  // vehicles[index1].location.time = element.t
                }
              }
            }

            for (let index2 = 0; index2 < filtered.length; index2++) {
              const filter = filtered[index2]
              const match = filter.id === element.v
              const timeTempNew = element.t2
              const timeTempOld = filter.location.time

              const dateTime1 = new Date(timeTempNew)
              const dateTime2 = new Date(timeTempOld)

              // console.log('--WB - dateTime1', dateTime1)
              // console.log('--WB - dateTime2', dateTime2)
              // console.log('--WB - dateTime1 <= dateTime2', dateTime1 <= dateTime2)

              const matchTime = dateTime1 > dateTime2
              // if (element.v === 1517 && match) console.log('filter', match, matchTime, element.v)
              // console.log('filter', match, matchTime)

              if (match) {
                if (matchTime) {
                  // console.log('WORKER REAL TIME MATCH', index1)
                  filtered[index2].location.time = element.t2
                  filtered[index2].location.ignitionStatus = element.is
                  filtered[index2].location.eventType = element.e
                  filtered[index2].location.lat = element.la
                  filtered[index2].location.lng = element.lo
                  filtered[index2].location.direction = element.di
                  filtered[index2].location.speed = element.sp
                  filtered[index2].location.GPSValid = element.gp
                  filtered[index2].stoppedTimeSinceV2 = element.st2
                  filtered[index2].mainBatteryVoltage = element.bat
                  filtered[index2].numberOfSatellites = element.sat
                  // filtered[index2].stoppedTime = element.st
                  // filtered[index2].initialStoppedTime = element.sit
                  // filtered[index2].initialStoppedTimeVerbose = element.sitV
                  // vehicles[index1].location.time = element.t
                }
              }
            }
          }
          const result = {vehicles, filtered}
          return result
        }
      }
    ]

    let worker = Vue.prototype.$worker.create(actions)

    // let arrayB1 = new ArrayBuffer(1)
    // let arrayB2 = new ArrayBuffer(1)

    const arrayB1 = state.lastPositionsInit
    const arrayB2 = data
    const arrayB3 = state.lastPositionFiltered

    const beforeFilterType = getters.filterType

    // console.log('before FILTER TYPE:', beforeFilterType)
    // console.log('before lastPositionFiltered:', state.lastPositionFiltered)

    worker.postMessage('realtime1', [arrayB1, arrayB2, arrayB3])
      .then(result => {
        // console.log('WORKER REAL TIME - THEN -', vehicles)
        // console.log('after FILTER TYPE:', getters.filterType)
        if (beforeFilterType !== getters.filterType) {
          // console.log('RESULT', result)
          result.filtered = []
        }
        // console.log('after lastPositionFiltered:', state.lastPositionFiltered)
        commit(types.REAL_TIME_VEHICLES, result)
      })
      .catch(error => {
        console.error('WORKER ERROR [realtimeVehiclesData]: ', error)
      })
  },
  filterByAgency({commit, dispatch, state, getters, rootGetters}, payload) {
    // dispatch('setFilterByAZ', false)
    dispatch('clearDataFiltered')
    dispatch('displayFiltersHome', false)
    dispatch('displayApplyFiltersHome', true)

    trackDataSearchedFilters({type: 'agency', data: payload.agencyIds})

    // console.log('Apply Agency Filter whith: ', payload.agencyIds, payload.mapref)
    let limits = []
    // console.log('state.stateVehicleFilter', state.stateVehicleFilter)
    // if (state.stateVehicleFilter !== 'V0') {
    // limits = limitsObj.get(state.stateVehicleSelected)
    state.stateVehicleSelected.forEach(element => {
      limits.push(limitsObj.get(element.value))
    })
    // }
    // console.log('LIMITS: ', limitsObj, state.stateVehicleSelected, limits)
    Vue.prototype.$worker.run((vehicles, ids, ignitionFilter, stateVehicleFilter, limits) => {
      let filterVehicles = []
      let result = false
      for (let index = 0; index < vehicles.length; index++) {
        const item = vehicles[index]

        for (let index1 = 0; index1 < ids.length; index1++) {
          const element = ids[index1]
          result = item.agencyId === element
          if (result) {
            filterVehicles.push(item)
            break
          }
        }
      }
      // ----------------------------------------
      // IGNITION FILTER
      // ----------------------------------------
      if (ignitionFilter) {
        const filterVehiclesOFF = []
        const filterVehiclesON = []
        for (let index = 0; index < filterVehicles.length; index++) {
          const item = filterVehicles[index]
          if (item.location.ignitionStatus === 1) filterVehiclesON.push(item)
          else filterVehiclesOFF.push(item)
        }

        if (ignitionFilter === 'OFF') filterVehicles = filterVehiclesOFF
        else filterVehicles = filterVehiclesON
      }
      // ----------------------------------------
      // VEHICLE STATE FILTER
      // ----------------------------------------
      if (stateVehicleFilter.length > 0) {
        const filterVehiclesTemp = []
        for (let index = 0; index < stateVehicleFilter.length; index++) {
          const element = stateVehicleFilter[index]
          if (element.value === 'V0') {
            // ----------------------------------------
            // VEHICLE MOVING
            // ----------------------------------------
            for (let index = 0; index < filterVehicles.length; index++) {
              const item = filterVehicles[index]
              if (item.stoppedTimeSinceV2 === '' && item.location.speed > 5) filterVehiclesTemp.push(item)
            }
          } else {
            // ----------------------------------------
            // VEHICLE WITH STOPPED TIME
            // ----------------------------------------
            // console.log('limits', limits)
            const _element = limits[index]
            const isLimit = _element.isLimit
            const limit1 = _element.limit1
            const limit2 = _element.limit2
            if (isLimit) {
              for (let index = 0; index < filterVehicles.length; index++) {
                const item = filterVehicles[index]
                const stoppedTimeSinceV2 = new Date(item.stoppedTimeSinceV2)
                const now = new Date()
                const stoppedTime = Math.round((now - stoppedTimeSinceV2) / 60000)
                if (limit1 !== 0 && stoppedTime < limit1 && item.location.speed < 5) {
                  filterVehiclesTemp.push(item)
                } else if (limit1 === 0 && stoppedTime >= limit2) {
                  filterVehiclesTemp.push(item)
                }
              }
            } else {
              for (let index = 0; index < filterVehicles.length; index++) {
                const item = filterVehicles[index]
                const stoppedTimeSinceV2 = new Date(item.stoppedTimeSinceV2)
                const now = new Date()
                const stoppedTime = Math.round((now - stoppedTimeSinceV2) / 60000)
                if (stoppedTime >= limit1 && stoppedTime < limit2) filterVehiclesTemp.push(item)
              }
            }
          }
        }
        filterVehicles = filterVehiclesTemp
      }
      // ----------------------------------------
      return filterVehicles
    }, [
      state.lastPositionsInit,
      payload.agencyIds,
      state.ignition,
      state.stateVehicleSelected,
      limits
    ])
      .then(filterVehicles => {
        const bounds = new google.maps.LatLngBounds()
        filterVehicles.forEach(element => {
          bounds.extend(element.location)
        })
        if (filterVehicles.length > 0) {
          const area = zoomMapBoundaries(bounds)
          if (area > 100000) {
            // console.log('Area FBA > 100000')
            payload.mapref.fitBounds(bounds)
          } else {
            // console.log('Area FBA <= 100000')
            const extraPadding = 100
            payload.mapref.fitBounds(bounds, extraPadding)
            payload.mapref.setZoom(17)
          }
          // if (filterVehicles.length === 1) payload.mapref.setZoom(16)
        } else {
          bounds.extend({lat: 6.254790211409118, lng: -75.551029793457})
          payload.mapref.fitBounds(bounds)
          // payload.mapref.$mapObject.setZoom(13)
          payload.mapref.setZoom(13)
        }

        // console.log('THEN FROM WORKER :')
        // console.log('FILER BY AGENCY ID: ', filterVehicles)
        dispatch('displayApplyFiltersHome', false)
        dispatch('addFilterTypeHome', `Agencia | ${getters.agencySelected.name}`)
        commit(types.FETCH_FILTERED_VEHICLES, filterVehicles)
        // commit(types.SET_IGNITION_FILTER, null)
        // commit(types.SET_STATE_VEHICLE_FILTER, [])
        dispatch('setFilterByAZ', true)
        // Set log for this filter
        const payloadLog = {
          event: 'searched',
          eventDescription: 'filters',
          dataAction: rootGetters.payloadSearchedFilters,
          modelId: '',
          modelType: rootGetters.modelTypeSearchedFilters,
          product: 'front-preloaded-data-filter'
        }
        dispatch('setLogHistoryFront', payloadLog)
      })
      .catch(error => {
        console.error('WORKER ERROR [filterByAgency]: ', error)
        dispatch('displayApplyFiltersHome', false)
      })
  },
  filterByZone({commit, dispatch, rootGetters}, payload) {
    // console.log('FILTER BY ZONE :', payload)
    // dispatch('setFilterByAZ', false)
    dispatch('setFilterApplied', false)
    dispatch('displayFiltersHome', false)
    dispatch('displayApplyFiltersHome', true)

    trackDataSearchedFilters({
      type: 'zone',
      data: { name: payload.name, typeZone: payload.typeZone }
    })
    // const mapref = payload.mapRef.$mapObject
    const mapref = payload.mapRef

    // console.log('geostring: ', payload.geostring)
    if (payload.name === 'San Cristóbal' || payload.name === 'SUB San Cristóbal' || payload.name === 'San Javier' || payload.name === 'EST San Javier') {
      // const filterVehicles = []
      payload.geostring.forEach(element => {
        const coords = google.maps.geometry.encoding.decodePath(element)
        const payloadIn = {
          mapref,
          coords
        }
        dispatch('applyToMapFilter', payloadIn)
          .then(response => {
            // console.log('San Cristóbal / San Javier : ', response)
            // console.log('BEFORE stateVehicleSelected: ', state.stateVehicleSelected)
            dispatch('applyTunningFilterZone', response)
              .then(result => {
                // console.log('applyTunningFilterZone : ', result)
                commit(types.FETCH_FILTERED_VEHICLES_CONCAT, result)
                dispatch('displayApplyFiltersHome', false)
                dispatch('addFilterTypeHome', `Zona | ${payload.typeZone} | ${payload.name}`)
                // commit(types.SET_IGNITION_FILTER, null)
                // commit(types.SET_STATE_VEHICLE_FILTER, [])
                dispatch('setFilterByAZ', true)
              })
          })
      })
      // console.log('filterVehicles: ', filterVehicles)
      // dispatch('displayApplyFiltersHome', false)
      // dispatch('addFilterTypeHome', `Zona | ${payload.typeZone} | ${payload.name}`)
    } else {
      const coords = google.maps.geometry.encoding.decodePath(payload.geostring)
      const payloadIn = {
        mapref,
        coords
      }
      dispatch('applyToMapFilter', payloadIn)
        .then(response => {
          dispatch('applyTunningFilterZone', response)
            .then(response => {
              dispatch('displayApplyFiltersHome', false)
              dispatch('addFilterTypeHome', `Zona | ${payload.typeZone} | ${payload.name}`)
              commit(types.FETCH_FILTERED_VEHICLES, response)
              // commit(types.SET_IGNITION_FILTER, null)
              // commit(types.SET_STATE_VEHICLE_FILTER, [])
              dispatch('setFilterByAZ', true)
            })
        })
    }
    // Set log for this filter
    const payloadLog = {
      event: 'searched',
      eventDescription: 'filters',
      dataAction: rootGetters.payloadSearchedFilters,
      modelId: '',
      modelType: rootGetters.modelTypeSearchedFilters,
      product: 'front-preloaded-data-filter'
    }
    dispatch('setLogHistoryFront', payloadLog)
  },
  applyTunningFilterZone({state}, response) {
    // ----------------------------------------
    // IGNITION FILTER
    // ----------------------------------------
    if (state.ignition) {
      const filterVehiclesOFF = []
      const filterVehiclesON = []
      for (let index = 0; index < response.length; index++) {
        const item = response[index]
        if (item.location.ignitionStatus === 1) filterVehiclesON.push(item)
        else filterVehiclesOFF.push(item)
      }

      if (state.ignition === 'OFF') response = filterVehiclesOFF
      else response = filterVehiclesON
    }
    // ----------------------------------------
    // VEHICLE STATE FILTER
    // ----------------------------------------
    if (state.stateVehicleSelected.length > 0) {
      const filterVehiclesTemp = []
      for (let index = 0; index < state.stateVehicleSelected.length; index++) {
        const element = state.stateVehicleSelected[index]
        let limits = null
        limits = limitsObj.get(element.value)
        if (element.value === 'V0') {
          // ----------------------------------------
          // VEHICLE MOVING
          // ----------------------------------------
          for (let index = 0; index < response.length; index++) {
            const item = response[index]
            if (item.stoppedTimeSinceV2 === '' && item.location.speed > 5) filterVehiclesTemp.push(item)
          }
        } else {
          // ----------------------------------------
          // VEHICLE WITH STOPPED TIME
          // ----------------------------------------
          const isLimit = limits.isLimit
          const limit1 = limits.limit1
          const limit2 = limits.limit2
          if (isLimit) {
            for (let index = 0; index < response.length; index++) {
              const item = response[index]
              const stoppedTimeSinceV2 = new Date(item.stoppedTimeSinceV2)
              const now = new Date()
              const stoppedTime = Math.round((now - stoppedTimeSinceV2) / 60000)
              if (limit1 !== 0 && stoppedTime < limit1 && item.location.speed < 5) {
                filterVehiclesTemp.push(item)
              } else if (limit1 === 0 && stoppedTime >= limit2) {
                filterVehiclesTemp.push(item)
              }
            }
          } else {
            for (let index = 0; index < response.length; index++) {
              const item = response[index]
              const stoppedTimeSinceV2 = new Date(item.stoppedTimeSinceV2)
              const now = new Date()
              const stoppedTime = Math.round((now - stoppedTimeSinceV2) / 60000)
              if (stoppedTime >= limit1 && stoppedTime < limit2) filterVehiclesTemp.push(item)
            }
          }
        }
      }
      response = filterVehiclesTemp
    }
    return response
    // ----------------------------------------
  },
  applyToMapFilter({state, commit}, {mapref, coords}) {
    const filterVehicles = []
    const polygon = new google.maps.Polygon({
      paths: coords
    })
    // console.log('POLYGON applyToMapFilter', polygon)
    for (let index = 0; index < state.lastPositionsInit.length; index++) {
      const element = state.lastPositionsInit[index]
      const location = new google.maps.LatLng(element.location.lat, element.location.lng)
      const vehicleInside = google.maps.geometry.poly.containsLocation(location, polygon)
      if (vehicleInside) filterVehicles.push(element)
    }
    // commit(types.FILTER_APPLIED, true)
    return filterVehicles
  },
  clearDataFiltered({commit}) {
    commit(types.INIT_DATA_FILTERED)
  },
  addGeostringFilters({commit}, data) {
    commit(types.ADD_GEOSTRING_FILTERS, data)
  },
  clearSearch({commit}, mapRef) {
    const bounds = new google.maps.LatLngBounds()
    bounds.extend({lat: 6.254790211409118, lng: -75.551029793457})
    mapRef.fitBounds(bounds)
    mapRef.setZoom(13)
    commit(types.SET_SEARCHED_VEHICLE_HOME, [])
    commit(types.SEARCHING_VEHICLE, false)
  },
  clearFilterSearch({commit, dispatch}, mapRef) {
    const bounds = new google.maps.LatLngBounds()
    bounds.extend({lat: 6.254790211409118, lng: -75.551029793457})
    mapRef.fitBounds(bounds)
    mapRef.setZoom(13)
    dispatch('addFilterTypeHome', '')
    commit(types.INIT_DATA_FILTERED)
    commit(types.FILTER_APPLIED, false)
    dispatch('setFilterByAZ', false)
  },
  setChipSerialYesNot({commit}, value) {
    commit(types.CHIP_SERIAL_YES_NOT, value)
  },
  addVehicleDataTemp({commit}, data) {
    commit(types.ADD_VEHICLE_DATA_TEMP, data)
  },
  searchVehicleAction({commit, state}, data) {
    commit(types.SEARCHING_VEHICLE, true)
    return state.lastPositionsInit.filter(item => item.code === data || item.licensePlate === data)
  },
  setIgnitionFilter({commit}, value) {
    commit(types.SET_IGNITION_FILTER, value)
  },
  setStateVehicleSelectedFilter({commit}, data) {
    commit(types.SET_STATE_VEHICLE_FILTER, data)
  },
  setSearchedVehicleAction({commit}, data) {
    commit(types.SET_SEARCHED_VEHICLE_HOME, data)
  },
  getInMissionDataKPI({commit}) {
    return new Promise(async(resolve, reject) => {
      try {
        await fetchInMission()
          .then(data => {
            if (data.data) {
              // console.log('processInMissionData DATA: ', data)
              commit(types.SET_IN_MISSION_DATA_FULL, data.data)
            }
            resolve('success')
          })
          .catch(error => {
            resolve('error')
            console.error('ERROR getInMissionDataKPI', error)
            reject(new Error(error.response))
          })
      } catch (e) {
        console.error(e)
        reject(e)
      }
    })
  },
  setCancelTokenInMissionData({commit}, token) {
    commit(types.SET_CANCEL_TOKEN_IN_MISSION_DATA, token)
  },
  setInfoWinOpen({commit}, value) {
    commit(types.SET_INFO_WIN_OPEN, value)
  }
}
// MUTATIONS
const mutations = {
  [types.UPDATE_IN_MISSION_DATA](state, data) {
    const arrayToUpdate = state.filterByAZ ? 'lastPositionFiltered' : 'lastPositionsInit'
    // console.log('arrayToUpdate: ', arrayToUpdate)
    for (let index = 0; index < data.length; index++) {
      const element = data[index]
      const indexIn = state[arrayToUpdate].findIndex(item => item.id === element.vehicleId)
      if (indexIn !== -1) state[arrayToUpdate][indexIn].inMission = element.inMission
    }
    // console.log('FINISHED -- UPDATE_IN_MISSION_DATA!!!!')
  },
  [types.UPDATE_STATUSES_DEVICES_VEHICLE_DATA](state, data) {
    const statuses = data.statuses
    let resultS = statuses.sort(function(a, b) {
      const textA = a.time
      const textB = b.time
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    })

    const devices = data.devices
    let resultD = devices.sort(function(a, b) {
      const textA = a.pivot.activationTimestamp
      const textB = b.pivot.activationTimestamp
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    })

    const currentDeviceOld = state.vehicleData.currentDevice
    if (data.currentDevice === null) {
      resultS.splice(0, 0, data.status)
      state.vehicleData = data
    } else if (currentDeviceOld === null && data.currentDevice) state.vehicleData = data

    state.statuses = resultS
    state.devices = resultD
  },
  [types.UPDATE_VEHICLE_IN_MISSION_PUSHER](state, data) {
    const inMission = data.inMission
    const index = state.lastPositionsInit.findIndex(item => item.id === data.vehicleId)
    if (index !== -1) {
      state.lastPositionsInit[index].inMission = String(inMission)
      if (
        state.selectedVehicle &&
        data.vehicleId === state.selectedVehicle.id
      ) state.selectedVehicle.inMission = inMission
    }
  },
  [types.UPDATE_VEHICLE_STATUS_PUSHER](state, data) {
    const status = data.s.translatedName
    const index = state.lastPositionsInit.findIndex(item => item.id === data.v)
    // if (index !== -1) Vue.set(state.lastPositionsInit[index].status, 'translatedName', status)
    if (index !== -1) {
      if (data.v === state.selectedVehicle.id) state.selectedVehicle.status = data.s
      state.lastPositionsInit[index].status.translatedName = status
    }
  },
  [types.SET_IS_FILTERING](state, value) {
    state.isFiltering = value
  },
  [types.SET_IN_MISSION_FILTER](state, value) {
    state.inMissionFilter = value
  },
  [types.ADD_ST2_SELECTED_VEHICLE](state, value) {
    state.selectedVehicle.stoppedTimeSinceV2 = value
  },
  [types.UPDATE_SELECTED_VEHICLE](state, data) {
    state.selectedVehicle.location = data.location
    state.selectedVehicle.stoppedTimeSinceV2 = data.stoppedTimeSinceV2
    state.selectedVehicle.mainBatteryVoltage = data.mainBatteryVoltage
    state.selectedVehicle.numberOfSatellites = data.numberOfSatellites
  },
  [types.SET_FILTER_BY_AZ](state, value) {
    state.filterByAZ = value
  },
  [types.SET_CURRENT_MARKERS_LENGTH](state, value) {
    state.currentMarkersLength = value
  },
  [types.SET_FILTER_CONDITION](state, data) {
    if (state.lastPositionFiltered.length > 0) {
      state.filteredTempAll = state.lastPositionFiltered
    } else {
      state.filteredTempAll = state.lastPositionsInit
      // state.lastPositionsInit = data
    }
    state.lastPositionFilteredCondition = data
    // state.lastPositionsInit = data
  },
  [types.UPDATE_FILTER_CONDITION](state, value) {
    state.filterCondition = value
  },
  [types.UPDATE_STATUS_VEHICLE_DATA](state, data) {
    // console.log('UPDATE_STATUS_VEHICLE_DATA: ', data)
    // state.vehicleData.status = data
    Vue.set(state.vehicleData, 'status', data)
    // console.log('NEW VEHICLE DATA: ', state.vehicleData)
  },
  [types.FILTER_APPLIED](state, value) {
    state.filterApplied = value
  },
  [types.SET_MAIN_AGENCY](state, data) {
    state.mainAgency = data
  },
  [types.UP_VEHICLE](state, data) {
    // console.log('UP_VEHICLE', data.operation, data.vehicle)
    state.lastPositionsInit.push(data.vehicle)
  },
  [types.UPDATE_VEHICLE](state, data) {
    // console.log('UPDATE_VEHICLE', data.operation, data.vehicle)
    const id = data.vehicle.id
    const index = state.lastPositionsInit.findIndex(item => item.id === id)
    // console.log('INDEX: ', index)
    if (index !== -1) state.lastPositionsInit.splice(index, 1, data.vehicle)
  },
  [types.DOWN_VEHICLE](state, data) {
    // console.log('DOWN_VEHICLE', data.operation, data.vehicle)
    const id = data.vehicle.id
    const index = state.lastPositionsInit.findIndex(item => item.id === id)
    // console.log('INDEX: ', index)
    if (index !== -1) state.lastPositionsInit.splice(index, 1)
  },
  [types.SET_SEARCHED_VEHICLE_HOME](state, data) {
    state.lastPositionSearch = data
    state.showClearSearchBtn = state.lastPositionSearch.length > 0
  },
  [types.SET_STATE_VEHICLE_FILTER](state, data) {
    if (data === undefined) data = []
    state.stateVehicleSelected = data
  },
  [types.SET_IGNITION_FILTER](state, value) {
    if (value === undefined) value = null
    state.ignition = value
  },
  [types.VEHICLES_WITHOUT_AGENCY](state, data) {
    state.vehiclesWithoutAgency = data
  },
  [types.SEARCHING_VEHICLE](state, value) {
    state.searchVehicle = value
  },
  [types.ADD_VEHICLE_DATA_TEMP](state, data) {
    state.vehicleDataTemp[data.key] = data.value
  },
  [types.CHIP_SERIAL_YES_NOT](state, value) {
    state.chipSerialYesNot = value
  },
  [types.FETCH_VEHICLE_TYPES](state, data) {
    const preMap = []
    data.data.forEach(element => {
      preMap.push([element.key, element.value])
    })
    const vehicleTypesMap = new Map(preMap)
    state.vehicleTypes = vehicleTypesMap
  },
  [types.SHOW_LOADING_VEHICLE_DATA](state, value) {
    state.showLoadingVehicleData = value
  },
  [types.ADD_GEOSTRING_FILTERS](state, data) {
    state.geostringFilters = data
  },
  [types.INIT_DATA_FILTERED](state) {
    state.showClearFilterBtn = false
    state.geostringFilters = null
    state.lastPositionFiltered = []
  },
  [types.ADD_LAST_POLYGONS_FILTER](state, data) {
    state.lastPolygonsFilter = data
  },
  [types.FETCH_FILTERED_VEHICLES_CONCAT](state, data) {
    state.lastPositionFiltered = state.lastPositionFiltered.concat(data)
    state.showClearFilterBtn = true
  },
  [types.FETCH_FILTERED_VEHICLES](state, data) {
    state.lastPositionFiltered = data
    state.showClearFilterBtn = true
  },
  [types.LAST_POSITIONS_INIT](state, data) {
    state.lastPositionsInit = data
  },
  [types.SET_ALL_VEHICLES_UNFILTERED](state, data) {
    state.allVehiclesUnfiltered = data
  },
  [types.REAL_TIME_VEHICLES](state, data) {
    state.lastPositionsInit = data.vehicles
    if (data.filtered.length > 0) state.lastPositionFiltered = data.filtered
  },
  [types.FILL_VEHICLE_DATA](state, data) {
    state.vehicleData = data
    state.vehicleDataTemp['agencyId'] = data.agencyId
    state.vehicleDataTemp['brand'] = data.brand
    state.vehicleDataTemp['color'] = data.color
    state.vehicleDataTemp['fuelType'] = data.fuelType
    state.vehicleDataTemp['licensePlate'] = data.licensePlate
    state.vehicleDataTemp['model'] = data.model
    state.vehicleDataTemp['vehicleType'] = data.vehicleType
    // state.vehicleData.model = String(data.model)

    const statuses = data.statuses
    let resultS = statuses.sort(function(a, b) {
      const textA = a.time
      const textB = b.time
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    })
    // console.log('resultS', resultS)
    state.statuses = resultS

    const devices = data.devices
    let resultD = devices.sort(function(a, b) {
      const textA = a.pivot.activationTimestamp
      const textB = b.pivot.activationTimestamp
      return (textA > textB) ? -1 : (textA < textB) ? 1 : 0
    })
    // console.log('resultD', resultD)
    state.devices = resultD
  },
  [types.CONTROL_MESSAGE](state, data) {
    state[data.nameA] = data.show
    state[data.nameM] = data.message
  },
  [types.ADD_VEHICLE_DATA](state, data) {
    state.vehicleData[data.key] = data.value
  },
  [types.SHOW_POINTS](state, value) {
    state.showPointsSection = value
  },
  [types.SHOW_POINTS_MESSAGE](state, value) {
    state.showPointsMessage = value
  },
  [types.FETCH_VEHICLES](state, vehicles) {
    state.vehicles = vehicles
  },
  [types.UPDATE_VEHICLE_POSITION](state, updatedVehicle) {
    const {id, lastPosition} = updatedVehicle.vehicle
    const speed = lastPosition.speed
    const {lat, lng} = lastPosition
    if (state.selectedVehicle !== null && state.selectedVehicle.id === id) {
      state.selectedVehicle.lastPosition = {
        ...state.selectedVehicle.lastPosition,
        lat,
        lng,
        speed
      }
    }
    state.vehicles = state.vehicles.map(vehicle => {
      if (vehicle.id === id) {
        vehicle.lastPosition = {
          ...vehicle.lastPosition,
          lat,
          lng,
          speed
        }
      }
      return vehicle
    })
  },
  [types.SELECT_VEHICLE](state, vehicle) {
    state.selectedVehicle = vehicle
  },
  [types.SET_IN_MISSION_DATA_FULL](state, data) {
    state.inMissionDataFullKPI = data
  },
  [types.SET_CANCEL_TOKEN_IN_MISSION_DATA](state, value) {
    state.cancelTokenInMissionData = value
  },
  [types.SET_INFO_WIN_OPEN](state, value) {
    state.infoWinOpen = value
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/vehicles.js